module.exports = __webpack_public_path__ + "static/video_tb_jp-d76f552c080736a925fc6130ee011f6b.mp4";